import React from 'react';
import './tournaments.css';

/**
 * Tournament display (no longer a switcher — shows active tournament name).
 */
const Tournaments = ({ tournamentName }) => {
  if (!tournamentName) return null;

  return (
    <div className="tournament-switch">
      <div className="tournament-option active-tournament">
        <span>{tournamentName}</span>
      </div>
    </div>
  );
};

export default Tournaments;
